import React, { useState, useContext } from 'react';
import { Frown } from 'react-feather';
import Modal from '../Modal/Modal';
import styles from './LoseBanner.module.css';
import { LanguageContext } from '../App';
import localisation from '../../localisation.json';

function LoseBanner({ correctAnswer, children }) {
    const [isOpen, setIsOpen] = useState(true);
    const { language } = useContext(LanguageContext);
    return (
        <Modal
            withDelay
            isOpen={isOpen}
            title={
                <div className={styles.title}>
                    {localisation[0].loseBanner.header[language]}
                    <Frown size={24} color='gold' />
                </div>
            }
            handleDismiss={() => setIsOpen(false)}>
            <div className={styles.details}>
                {localisation[0].loseBanner.correctWordText[language]}{' '}
                {correctAnswer}
            </div>
            <div className={styles.actions}>{children}</div>
        </Modal>
    );
}

export default LoseBanner;
